import request from '@/config/axios'

export interface HomeSceneVO {
  id?: number
  caseType: string
  title: string
  prompt: string
  tone?: string
  icon?: string
  sort: number
  status: number
  createTime?: string
}

export interface HomeScenePageReqVO {
  pageNo?: number
  pageSize?: number
  caseType?: string
  title?: string
  status?: number
}

export const HomeSceneApi = {
  getPage: async (params: HomeScenePageReqVO) => {
    return await request.get({ url: '/lawyer/home-scene/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/lawyer/home-scene/get', params: { id } })
  },
  create: async (data: HomeSceneVO) => {
    return await request.post({ url: '/lawyer/home-scene/create', data })
  },
  update: async (data: HomeSceneVO) => {
    return await request.put({ url: '/lawyer/home-scene/update', data })
  },
  updateStatus: async (id: number, status: number) => {
    return await request.put({ url: '/lawyer/home-scene/update-status', params: { id, status } })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/lawyer/home-scene/delete', params: { id } })
  }
}
